import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const WIZARD_STORAGE_KEY = 'merchantWizardPosition';

export const getMerchantWizardState = (defaultValue = 'court') => {
    try {
        return localStorage.getItem(WIZARD_STORAGE_KEY) || defaultValue;
    } catch (e) {
        return defaultValue;
    }
};

export const setMerchantWizardState = (value) => {
    try {
        localStorage.setItem(WIZARD_STORAGE_KEY, value);
    } catch (e) {
        console.error('Failed to save merchant wizard state', e);
    }
};

export const clearMerchantWizardState = () => {
    try {
        localStorage.removeItem(WIZARD_STORAGE_KEY);
    } catch (e) {
        console.error('Failed to clear merchant wizard state', e);
    }
};

/**
 * Keep wizard state only while user is inside merchant pages.
 * Reset it when user leaves merchant route.
 */
export const useResetMerchantWizardOnLeave = () => {
    const location = useLocation();

    useEffect(() => {
        const isMerchantPage = /^\/[^/]+\/merchants(\/|$)/.test(location.pathname);

        if (!isMerchantPage) {
            clearMerchantWizardState();
        }
    }, [location.pathname]);
};